// extracted by mini-css-extract-plugin
export default {"loaderContainer":"KeraltyLoader_loaderContainer__QUxlF"};